import { createFilter } from './filters/index.js';
// ********************************
// **** TYPE DEFINITIONS - END ****
// ********************************
const isBrowser = typeof window !== 'undefined';
/**
 * Console notifier with limited functionality that does not send notices to airbrake.
 * It prints the notice to the console. Works both on the server and client side.
 * Method signatures are aligned with Notifier from @airbrake/browser
 */
export class ConsoleNotifier {
    addFilter( /* filter: Filter */) { }
    // eslint-disable-next-line
    notify(err) {
        console.warn('[Airbrake ConsoleNotifier]:', err);
        return Promise.resolve({ /* blank INotice */});
    }
}
/**
 * A No Operation (NOOP) Notifier. Provides empty implementation for
 * `addFilter` and `notify`. Used as a fallback when instantiating the
 * Notifier from the airbrake libraries fails.
 */
export class NoopNotifier {
    addFilter( /* filter: Filter */) { }
    notify( /*err: any*/) {
        return Promise.resolve({ /* blank INotice */});
    }
}
let notifier = new NoopNotifier();
export { notifier };
const getAirbrake = () => notifier;
export default getAirbrake;
/**
 * Creates an Airbrake Notifier using the `options.NotifierClass` constructor.
 * If the instantiation fails it falls back to the NoopNotifier.
 *
 * @param options AirbrakeOptions
 * @return Notifier
 */
export function createAirbrakeClient(options) {
    const { projectId, useDefaultFilter, NotifierClass } = options;
    delete options.useDefaultFilter;
    try {
        notifier = new NotifierClass({
            ...options,
            // overrides for options
            projectId: parseInt(`${projectId}`),
            NotifierClass: undefined // NotifierClass is not needed in Airbrake Notifier constructors
        });
        if (((useDefaultFilter !== null && useDefaultFilter !== void 0 ? useDefaultFilter : true) && isBrowser)) {
            notifier.addFilter(createFilter({
                sampleRatePercentage: 0,
                messagePattern: [
                    // APPS-2105 - likely caused by some automation running on in an individual’s browser.
                    /Failed to execute 'querySelectorAll' on 'Document': .*iframe.* is not a valid selector/,
                    // APPS-2120 - LastPass browser extension error on Safari exclusively
                    'Not implemented on this platform',
                    // APPS-2121 - caused by the Grammarly browser extension
                    'Identifier \'originalPrompt\' has already been declared',
                    // APPS-2122 - caused by the 1Password browser extension
                    'Error response received for message <get-frame-manager-configuration>'
                ]
            }));
            // Backtrace filters
            [
                'webkit-masked-url',
                'chrome-extension' // APPS-2119 - The chrome-extension:// stack trace items are reported to be originating from Chrome extensions
            ].forEach(backtracePattern => {
                notifier.addFilter(createFilter({
                    sampleRatePercentage: 0,
                    backtracePattern,
                    backtracePatternMatch: 'any'
                }));
            });
        }
    }
    catch (err) {
        // Let `client` fall back to `NoopNotifier` in case importing or initializing the node/browser Notifier fails.
    }
    return notifier;
}
export function createConsoleNotifier() {
    notifier = new ConsoleNotifier();
    return notifier;
}
export * from './filters/index.js';
/**
 * Note that below code is only needed because some apps on an older stack (e.g. Ash)
 * are unable to import directly from the lib entry points as defined in the exports section of package.json.
 * E.g. they cannot import from `@doxo/willow-airbrake/browser`. Nor can they handle
 * the `export * as browser from './browser.js'` syntax, thus we are using here a bit clumsy solution.
 */
import { createAirbrakeClient as createAirbrakeClientBrowser } from './browser.js';
export const browser = { createAirbrakeClient: createAirbrakeClientBrowser };



// WEBPACK FOOTER //
// ./node_modules/@doxo/willow-airbrake/dist/esm/index.js